import PropTypes from "prop-types";
import Box from "@mui/material/Box";
import GrIconTile from "./GrIconTile";
import { gr } from "../tokens";

// Empty state: what is missing, what will appear, and (optionally) the one action to fill it.
// compact (inside cards): smaller icon and a quiet 14px message instead of a 16px heading.
// feature (a whole empty pane, e.g. "Select a chat"): large round brand icon above the heading.
export default function GrEmptyState({
  icon,
  title,
  text,
  action,
  compact = false,
  feature = false,
  sx,
}) {
  return (
    <Box
      sx={{
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        textAlign: "center",
        gap: gr.space[2],
        py: compact ? gr.space[4] : gr.space[8],
        px: gr.space[4],
        ...sx,
      }}
    >
      {icon && feature ? (
        <Box
          aria-hidden
          sx={{
            width: `calc(${gr.space[12]} * 2)`,
            height: `calc(${gr.space[12]} * 2)`,
            mb: gr.space[2],
            borderRadius: gr.radius.pill,
            background: gr.color.brandSoft,
            color: gr.color.brand,
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            "& svg": { width: gr.space[12], height: gr.space[12] },
          }}
        >
          {icon}
        </Box>
      ) : icon ? (
        <GrIconTile
          size={compact ? "md" : "lg"}
          tone="neutral"
          sx={{ mb: gr.space[1] }}
        >
          {icon}
        </GrIconTile>
      ) : null}
      <Box
        component="p"
        sx={{
          m: 0,
          maxWidth: 420,
          fontSize: compact ? gr.font.size.md : gr.font.size.lg,
          fontWeight: compact ? gr.font.weight.medium : gr.font.weight.semibold,
          color: compact ? gr.color.ink2 : gr.color.ink,
        }}
      >
        {title}
      </Box>
      {text ? (
        <Box
          component="p"
          sx={{
            m: 0,
            maxWidth: 420,
            fontSize: gr.font.size.sm,
            color: gr.color.ink2,
          }}
        >
          {text}
        </Box>
      ) : null}
      {action ? <Box sx={{ mt: gr.space[2] }}>{action}</Box> : null}
    </Box>
  );
}

GrEmptyState.propTypes = {
  icon: PropTypes.node,
  title: PropTypes.node.isRequired,
  text: PropTypes.node,
  action: PropTypes.node,
  compact: PropTypes.bool,
  feature: PropTypes.bool,
  sx: PropTypes.object,
};
